<template>
  <div class="right-index">
    <div class="right-box" v-loading="loading">
      <div class="page-title">
        <i class="iconfont iconic_lishijilu"></i>
        <span>历史记录查看</span>
      </div>
      <div class="sub-title" style="margin-bottom:27px">{{eventList.length>0 ? '处理进度' :'尚未提交反馈'}}</div>
      <div class="progress-box" v-for="item in eventList" :key="item.event_id">
        <p class="date-text">
          <i class="iconfont iconic_tianjiashijian"></i>
          <span>提交时间：{{handleDate(item.date_create)}}</span>
        </p>
        <div class="progress-wrapper">
          <div class="real-progress" :style="{'width':getProgress(item.cover,item.total)}">
            <div class="progress-dot">
              <img
                v-if="item.cover"
                src="../../../assets/img/phoneFeedback/progress-dot.png"
                alt=""
              >
            </div>
          </div>
        </div>
        <div class="border-text">
          <span>已处理/已反馈：</span>
          <span
            class="num"
            @click="showDetail(item.type,item.cover,item.total,item.event_id)"
          >{{item.cover?item.cover:0}}/{{item.total}}</span>
        </div>
        <div class="plain-text">
          <span>手机号码类型：</span>
          <span>{{item.type===1 ? '漏报':'误报'}}</span>
        </div>
      </div>
      <div class="pagination-box">
        <el-pagination
          small
          layout="prev, pager, next"
          v-if="eventList.length>0"
          :total="total"
          :page-size="5"
          :current-page="parmas.page"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getPhoneAllEvent } from '@/services/interface'
import { formatDate } from '@/util/common'
export default {
  data () {
    return {
      eventList: [], // 事件列表
      total: 0, // 事件总数
      parmas: { // 查询参数
        page: 1,
        pageSize: 5
      },
      loading: false
    }
  },
  methods: {
    /**
     * 页码变更
     * @param value: 页码
     */
    pageChange (value) {
      this.parmas.page = value
      this.getPhoneAllEvent()
    },

    /**
     * 提交事件给父组件
     */
    showDetail (type, cover, total, eventId) {
      const detailParams = {
        type,
        cover,
        total,
        event_id: eventId
      }
      this.$emit('showDetail', detailParams)
    },

    /**
     * 处理时间格式
     * @param date:时区格式
     */
    handleDate (date) {
      return formatDate(new Date(date))
    },

    /**
     * 计算百分比
     * @param cover:覆盖量
     * @param total:总数
     */
    getProgress (cover, total) {
      if (!cover) {
        return '0%'
      }
      return parseInt(cover / total * 100) + '%'
    },

    async getPhoneAllEvent () {
      this.loading = true
      const res = await getPhoneAllEvent(this.parmas).then((res) => {
        return res
      })
      this.loading = false
      this.eventList = res.data.data
      this.total = res.data.total
    },

    /**
     * 初始化数据
     */
    initData () {
      this.parmas.page = 1
      this.getPhoneAllEvent()
    }
  },
  async created () {
    this.initData()
  }
}
</script>

<style scoped>
.right-index {
  padding-top: 57px;
}
.right-box {
  width: 260px;
  padding: 24px 20px 0 20px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  box-sizing: border-box;
  height: 100%;
  margin-left: 20px;
}
.page-title {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}
.page-title i {
  font-size: 18px;
  margin-right: 8px;
  color: #003d92;
}
.page-title span {
  font-size: 14px;
  font-weight: 400;
  color: rgba(59, 60, 64, 1);
  line-height: 18px;
}
.sub-title {
  padding-left: 6px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(59, 60, 64, 1);
  line-height: 16px;
  border-left: 4px solid #003d92;
  margin-bottom: 16px;
}
.progress-box {
  margin-bottom: 36px;
}
.progress-box .date-text {
  display: flex;
  align-items: center;
  color: rgba(59, 60, 64, 1);
  margin-bottom: 8px;
  font-size: 12px;
}
.progress-box .date-text i {
  margin-right: 8px;
  font-size: 14px;
}
.progress-wrapper {
  height: 6px;
  background: rgba(228, 231, 237, 1);
  border-radius: 3px;
  position: relative;
  margin-bottom: 12px;
}
.progress-wrapper .real-progress {
  height: 6px;
  background: rgba(0, 61, 146, 1);
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 0;
}
.progress-dot {
  position: absolute;
  right: 0;
  width: 12px;
  height: 12px;
  top: -5px;
}
.progress-dot img {
  width: 100%;
  height: 100%;
}
.border-text {
  padding-bottom: 4px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eef0f5;
  margin-bottom: 4px;
}
.border-text span {
  font-size: 12px;
  font-weight: 400;
  color: rgba(59, 60, 64, 1);
  line-height: 18px;
}
.border-text .num {
  color: rgba(0, 61, 146, 1);
  text-decoration: underline;
  cursor: pointer;
}
.plain-text {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 400;
  color: rgba(59, 60, 64, 1);
  line-height: 18px;
}
.pagination-box {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
</style>
